import { useQuery } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var useShareLink = function useShareLink(patientUid, isOpen) {
  return useQuery(["share", patientUid], function () {
    return servicesUtils.getService("/patients/".concat(patientUid, "/share/"));
  }, {
    enabled: !!patientUid && isOpen
  });
};
export default useShareLink;